export const setTileIds = (products) => {
  const timesSeenMap = {};

  return products.map((product) => {
    const { id } = product;
    timesSeenMap[id] ||= 0;
    const timesSeenBefore = timesSeenMap[id]++;

    return {
      ...product,
      tileId: `${id}${timesSeenBefore ? `-${timesSeenBefore + 1}` : ""}`,
    };
  });
};
